/* jshint node:true */
'use strict';

var apiHost     = require('../helpers/utils/apiHost.js');
const DEFAULT_HOST = 'www.espn.co.uk'

module.exports = function(context, payload, done) {

    payload.query = payload.query || {};

    var sAPIHost    = apiHost.get(payload);
    var leagueId    = payload.query.league || payload.query.leagueId || 242041;
    var eventId     = payload.query.gameId || payload.query.eventId || 276523;
    var url         = '';
	
    if(leagueId && eventId){
        url = sAPIHost+'/apis/site/v2/sports/rugby/' + leagueId + '/summary?event=' + eventId;
    }

    context.service.get({
        url : url,
        done : function(data) {
            context.dispatch('RECEIVE_SCORES', data);
            
			/* hack to load pre-formated HTML for reports and previews */
			if(typeof data !== 'undefined' && typeof data.article !== 'undefined' && data.article !== null && typeof data.article.id !== 'undefined' ){
				const aPath = (typeof payload.pathname !== 'undefined') ? payload.pathname.split('/') : [];
				if(aPath[2] === 'report' || aPath[2] === 'preview' || aPath[2] === 'recap'){
					
					// set the gamepackage league and sport to allow video to work.
					try {
						if(typeof window.espn.gamepackage === null){
							window.espn.gamepackage = {}
						}
						if(typeof window.espn.gamepackage.league === null){
							window.espn.gamepackage.league = payload.query.league;
						}
						if(typeof window.espn.gamepackage.sport === null){
							window.espn.gamepackage.sport = 'rugby';
						}	
					}catch(e){}					
					
					var editionsHost = window ? window.location.hostname : 'www.espn.co.uk';
					if(editionsHost.indexOf('local.') === 0){
						editionsHost = editionsHost.replace('local.', 'www.')
					}else if(editionsHost.indexOf('localhost') === 0){
						editionsHost = DEFAULT_HOST;
					}
					context.service.get({
						url : 'http://'+editionsHost+'/rugby/story/_/id/'+data.article.id+'?render=true&partial=article&xhr=1',
						done : function(data) {
							context.dispatch('RECEIVED_ARTICLE', data);
							done();
						}
					});
				}else{
					done();
				}
			}else{
				done();
			}
        }
    });

};




/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/actions/loadScores.js
 **/